export const HERO_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/hero.jpg'
export const BOTTOM_HERO_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/bottom-hero.jpg'
export const BENEFITS_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/benefits.jpg'
export const GET_FEATURED_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/get-featured.jpg'
export const TOOLS_TEAM_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/tools-team.jpg'
export const CURATORS_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/curators.jpg'
// FAQ accordion sections
export const START_SELLING = 'start-selling'
export const WHO_CAN_SELL = 'who-can-sell'
export const WHAT_CAN_SELL = 'what-can-sell'
export const SHIPPING = 'shipping'
export const PAYMENT = 'payment'
export const COMMISSION = 'commission'
// Links
export const ARTIST_HANDBOOK_LINK = 'https://support.saatchiart.com/hc/en-us'
export const ARTIST_NEWSLETTER_LINK = 'https://www.saatchiart.com/signup/artist-newsletter'
export const SUPPORT_REQUEST_LINK = 'https://support.saatchiart.com/hc/en-us/requests/new'
export const CANVAS_LINK = 'https://canvas.saatchiart.com/category/art/artist-tips'
export const ARTIST_PROFILE_MANAGEMENT_LINK =
  'https://support.saatchiart.com/hc/en-us/sections/200723158-Artist-Profile-Management'
export const GETTING_STARTED_LINK =
  'https://support.saatchiart.com/hc/en-us/sections/200713637-Getting-Started'
export const MANAGING_ARTWORKS_LINK =
  'https://support.saatchiart.com/hc/en-us/sections/200722958-Managing-Your-Artworks'
export const SHIPPING_LINK =
  'https://support.saatchiart.com/hc/en-us/articles/204628968-I-ve-made-a-sale-What-do-I-do-now-'
export const ARTIST_PAYOUT =
  'https://support.saatchiart.com/hc/en-us/sections/200723468-Artist-Payout'
export const COMMISSION_LINK =
  'https://support.saatchiart.com/hc/en-us/articles/204629568-What-is-my-payout-percentage-for-sales-'
export const TESTIMONIAL_DATA = [
  {
    comment: `"The opportunity to reach a huge audience of art lovers through Saatchi Art is extraordinary, it has opened doors for me and sales have allowed me to develop as an artist."`,
    user: 'Sandy Dooley',
    link: 'https://www.saatchiart.com/sandydooley',
    location: 'London, UK',
    image: '//d3t95n9c6zzriw.cloudfront.net/whysell/artist-stories-dooley.jpg',
  },
  {
    comment: `Saatchi Art has afforded me two solo shows, collaborations and countless introductions to collectors, opening up my work to an international audience"`,
    user: 'Hormazd Narielwalla',
    link: 'https://www.saatchiart.com/narielwalla ',
    location: 'London, UK',
    image: '//d3t95n9c6zzriw.cloudfront.net/whysell/artist-stories-hormazd.jpg',
  },
  {
    comment: `"It's hard to overstate how important Saatchi Art has been to my creative development. Since joining in 2010, Saatchi Art has been with me every step of the way as I've launched what now seems like a career."`,
    user: 'Thomas Hammer',
    link: 'https://www.saatchiart.com/thomashammer',
    location: 'New York, USA',
    image: '//d3t95n9c6zzriw.cloudfront.net/whysell/artist-stories-hammer.jpg',
  },
  {
    comment: `"Recently a woman purchased one of my pieces through Saatchi Art and it was her first original work. Being directly involved in that process reminded me why I love to do what I do."`,
     
    user: 'Annie Terrazzo',
    link: 'https://www.saatchiart.com/annieterrazzo',
    location: 'Los Angeles, USA',
    image: '//d3t95n9c6zzriw.cloudfront.net/whysell/artist-stories-terrazzo.jpg',
  },
  {
    comment: `"Without Saatchi Art sales I would not be able to do my M.A. at The Royal College of Art London"`,
    user: 'Ben Edmunds',
    link: 'https://www.saatchiart.com/benedmunds',
    location: 'London, UK',
    image: '//d3t95n9c6zzriw.cloudfront.net/whysell/artist-stories-edmunds.jpg',
  },
]